
const checkEvaluation = [
  {
    path: '/check-evaluation',
    name: 'checkEvaluation',
    component: () => import('@/views/wxapp/check-evaluation'),
    meta: {
      title: '积木家装修体验点评'
    }
  }
]
export default checkEvaluation
